import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { useEffect, Fragment, useState } from "react";
import { Alert, Button, Card, Col, Form, FormGroup, OverlayTrigger, Popover, Row, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { getServiceStatusList } from "../../store/api/Services";
import { CheckLg, CheckSquare, DashCircle, ExclamationTriangle, PlusSquare, PlusSquareFill, Trash } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { getHappyCallMetrics, saveHappyCallSettings, getHappyCallCatList, addEditHappyCallQuestion, getHappyCallQuestion } from "../store/api/HappycallAPI";
import { setErrorDialog } from "../../store/api/CommonFunctions";
const HappyCallSettings = () => {
    const dispatch = useDispatch();
    const settingNames = ["Happycall_AlarmZone_Motavaset", "Happycall_AlarmZone_MotavasetBeBala", "Happycall_AlarmZone_MotavasetBePaeen", "Happycall_AlarmZone_Zaeef",
        "Happycall_Delay_DeliverdServices", "Happycall_Delay_SentServices", "Happycall_EnteranceStatusID", "Happycall_MetricsAnswerCount", "Happycall_SendHappycallSMSAutomatically",
        "Happycall_ShowDeliverdServices", "Happycall_ShowSentServices", "Happycall_ShowServicesInStatus", "Happycall_SMSAnswerDetector", "Happycall_SMSBody"]
    const { settings, statusList } = useSelector(state => { return { settings: state.SystemSettingsReducer.systemSettings, statusList: state.service.serviceStatusList } });
    const { register, handleSubmit, errors } = useForm();
    const [happyCallMetrics, setHappyCallMetrics] = useState({ Data: [] });
    const [currentMetric, setCurrentMetric] = useState(null);
    const [currentAnswer, setCurrentAnswer] = useState(null);
    const [catList, setCatList] = useState(null);
    const [submitError, setSubmitError] = useState(null);
    function findSetting(sName) {
        if (!settings || settings.length < 10) {
            return "";
        }
        return settings.find(s => s.SettingName === sName)?.SettingValue;
    }
    function findCheckedSetting(name) {
        if (!settings || settings.length < 10) {
            return false;
        }
        const setting = settings.find(s => s.SettingName === name);
        if (!setting) {
            return false;
        }
        return setting.SettingValue?.toLowerCase() === "true";
    }
    function saveSettings(data) {
        if (Array.isArray(data.Happycall_SendHappycallSMSAutomatically)) {
            data.Happycall_SendHappycallSMSAutomatically = data.Happycall_SendHappycallSMSAutomatically.some(h => h === "on");
        }
        if (Array.isArray(data.Happycall_ShowDeliverdServices)) {
            data.Happycall_ShowDeliverdServices = data.Happycall_ShowDeliverdServices.some(h => h === "on");
        }
        if (Array.isArray(data.Happycall_ShowSentServices)) {
            data.Happycall_ShowSentServices = data.Happycall_ShowSentServices.some(h => h === "on");
        }
        if (Array.isArray(data.Happycall_ShowServicesInStatus)) {
            data.Happycall_ShowServicesInStatus = data.Happycall_ShowServicesInStatus.some(h => h === "on");
        }
        const onSave = (res) => {
            if (res.Data) {
                setErrorDialog(dispatch, "success", "تنظیمات رضایت سنجی");
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "تنظیمات رضایت سنجی");
            }
        }
        saveHappyCallSettings(data, onSave);
    }
    function prepareForAdd() {
        setCurrentMetric({ ID: 0, AnswerList: [] });
    }
    function cancelMetric() {
        setCurrentMetric(null);
        setCurrentAnswer(null);
    }
    function currentAnswerChanged(e) {
        currentAnswer[e.target.name] = e.target.value;
    }
    function addEditAnswer() {
        if ((currentAnswer.AnswerText ?? "") === "") {
            setSubmitError("متن پاسخ وارد نشده است");
            return;
        }
        if (!currentAnswer.AnswerWeight) {
            currentAnswer.AnswerWeight = 0;
        }
        const answer = currentMetric.AnswerList.find(a => Number(a.AnswerNumber) === Number(currentAnswer.AnswerNumber));
        if (answer) {
            answer.AnswerText = currentAnswer.AnswerText;

        }
        else {
            currentMetric.AnswerList.push(currentAnswer);
        }
        setCurrentAnswer({ ID: 0 });
        const frmAddNewAnswer = document.getElementById("frmAddNewAnswer");
        frmAddNewAnswer.reset();
        // setCurrentMetric({ ...currentMetric });
    }
    function prepareForAddAnswer() {
        setCurrentAnswer({
            ID: 0
        })
    }
    function cancelAnswer() {
        setCurrentAnswer(null);
    }
    function deleteAnswer(number) {
        currentMetric.AnswerList = currentMetric.AnswerList.filter(a => Number(a.AnswerNumber) !== Number(number));
        setCurrentMetric({ ...currentMetric });
    }
    function submitQuestion() {
        setCurrentAnswer(null);
        if ((currentMetric.CategoryID ?? "") === "") {
            setSubmitError("دسته بندی پرسش انتخاب نشده است");
            return;
        }
        if ((currentMetric.QuestionText ?? "") === "") {
            setSubmitError("متن پرسش خالی است");
            return;
        }
        if (currentMetric.AnswerList.length === 0) {
            setSubmitError("لیست پاسخ ها خالی است");
            return;
        }
        if (!currentMetric.ItemOrderInInstall) {
            currentMetric.ItemOrderInInstall = 0;
        }
        if (!currentMetric.ItemOrderInRepair) {
            currentMetric.ItemOrderInRepair = 0;
        }
        if (currentMetric.WeightedMetrics) {
            const sumWeight = currentMetric.AnswerList.map(a => Number(a.AnswerWeight)).reduce((a, b) => a + b, 0);
            if (Number(sumWeight) === 0) {
                setSubmitError("مجموع وزن پاسخ ها باید بزرگتر از صفر باشد");
                return;
            }
        }
        const onSuccess = (res) => {
            if (res.Data) {
                setErrorDialog(dispatch, "success", "ثبت سوال رضایت سنجی");
                getHappyCallMetrics(setHappyCallMetrics);
                setCurrentMetric(null);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت سوال رضایت سنجی");
            }
        }
        addEditHappyCallQuestion(currentMetric, onSuccess);
    }
    function getQuestion(row) {
        const onGet = (res) => {
            if (res.Data) {
                setCurrentMetric(res.Data);
            }
        }
        getHappyCallQuestion(row.ID, onGet);
    }
    const popAddEditMetric =
        (
            <Popover show={false} id="popMetrics" style={{ maxWidth: "550px", minWidth: "550px", fontFamily: "Vazir" }}>
                <Popover.Title as="h3" className="headerStyle">
                    ثبت/ویرایش مقیاس
                </Popover.Title>
                <Popover.Content className="bodyStyle" style={{ padding: "10px", fontSize: "13px" }}>
                    {submitError &&
                        <Alert variant="danger"><ExclamationTriangle size={18} />&nbsp; {submitError}
                            <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setSubmitError(null)} />
                        </Alert>}
                    <Table>
                        <thead>
                            <tr>
                                <th style={{ padding: 0 }}></th>
                                <th style={{ padding: 0 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ width: "215px" }}>این مقیاس کدام مورد را ارزیابی می کند؟</td>
                                <td>
                                    <select className="tableRowInput" onChange={e => currentMetric.CategoryID = e.target.value} defaultValue={currentMetric?.CategoryID ?? ""}>
                                        <option value="">انتخاب کنید</option>
                                        {catList?.Data && Array.isArray(catList.Data) &&
                                            catList.Data.map((cat, i) => <option value={cat.ID} key={i}>{cat.CategoryName}</option>)}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "215px" }}>متن مقیاس: </td>
                                <td><textarea className="tableRowInput" onChange={e => currentMetric.QuestionText = e.target.value} defaultValue={currentMetric?.QuestionText ?? ""} /></td>
                            </tr>
                            <tr>
                                <td>
                                    <input type="checkbox" className="form-check-input" onChange={e => currentMetric.ActiveInInstall = e.target.checked} defaultChecked={currentMetric?.ActiveInInstall ?? false} />&nbsp;
                                    <label>فعال در سرویس نصب</label>
                                </td>
                                <td>
                                    <label>ترتیب نمایش در نظرسنجی نصب: </label>&nbsp;
                                    <input className="tableRowInput" type="number" style={{ width: "60px" }} onChange={e => currentMetric.ItemOrderInInstall = e.target.value} defaultValue={currentMetric?.ItemOrderInInstall ?? 0} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input type="checkbox" className="form-check-input" onChange={e => currentMetric.ActiveInRepair = e.target.checked} defaultChecked={currentMetric?.ActiveInRepair ?? false} />&nbsp;
                                    <label>فعال در سرویس تعمیر</label>
                                </td>
                                <td>
                                    <label>ترتیب نمایش در نظرسنجی تعمیر: </label>&nbsp;
                                    <input className="tableRowInput" type="number" style={{ width: "60px" }} onChange={e => currentMetric.ItemOrderInRepair = e.target.value} defaultValue={currentMetric?.ItemOrderInRepair ?? 0} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input type="checkbox" className="form-check-input" onChange={e => setCurrentMetric({ ...currentMetric, WeightedMetrics: e.target.checked })} defaultChecked={currentMetric?.WeightedMetrics ?? false} />&nbsp;
                                    <label>پاسخ ها داری وزن هستند</label>
                                </td>
                                <td style={{ backgroundColor: "gray" }}>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                    {currentAnswer &&
                        <form id="frmAddNewAnswer">
                            <div>
                                <input type="number" className="tableRowInput" style={{ width: "13%" }} placeholder="شماره پاسخ" name="AnswerNumber" onChange={currentAnswerChanged} />
                                <input className="tableRowInput" style={{ width: "62%" }} placeholder="متن پاسخ" name="AnswerText" onChange={currentAnswerChanged} />
                                <input className="tableRowInput" type="number" style={{ width: "13%" }} placeholder="وزن پاسخ" defaultValue={0} name="AnswerWeight" onChange={currentAnswerChanged} readOnly={!currentMetric?.WeightedMetrics} />
                                <Button className="btn-input-tiny" variant="success" style={{ top: "1px", left: "31px" }} onClick={addEditAnswer}><CheckSquare size={19} /></Button>
                                <Button className="btn-input-tiny" variant="danger" style={{ top: "1px", left: "0px" }} onClick={cancelAnswer}><DashCircle size={19} /></Button>
                            </div>
                        </form>
                    }
                    {!currentAnswer && <PlusSquareFill size={22} color="#2654e2f5" className="hoverIcon" onClick={prepareForAddAnswer} />}
                    <Table responsive className="mt-1">
                        <thead>
                            <th>شماره پاسخ</th>
                            <th>متن پاسخ</th>
                            <th>وزن پاسخ</th>
                            <th></th>
                        </thead>
                        <tbody>
                            {currentMetric?.AnswerList && Array.isArray(currentMetric.AnswerList) &&
                                currentMetric.AnswerList.map((answer, i) =>
                                    <tr key={i} className="resultTableRow">
                                        <td>{answer.AnswerNumber}</td>
                                        <td>{answer.AnswerText}</td>
                                        <td>{answer.AnswerWeight}</td>
                                        <td><Trash color="red" size={17} onClick={()=> deleteAnswer(answer.AnswerNumber)}/> </td>
                                    </tr>)
                            }
                        </tbody>
                    </Table>
                    <Button className="group-Btn" variant="success" onClick={submitQuestion}><CheckLg size={15} />&nbsp; ثبت تغییرات</Button>
                    <Button className="group-Btn" variant="danger" onClick={cancelMetric}><DashCircle size={15} />&nbsp; انصراف</Button>
                </Popover.Content>
            </Popover>
        )


    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "نام گروه", colName: "CategoryName", showInMobile: true },
        { colTitle: "متن سوال", colName: "QuestionText", showInMobile: true },
        { colTitle: "نصب", colName: "ActiveInInstall", colType: "boolean" },
        { colTitle: "ترتیب در نصب", colName: "ItemOrderInInstall" },
        { colTitle: "تعمیر", colName: "ActiveInRepair", colType: "boolean" },
        { colTitle: "ترتیب در تعمیر", colName: "ItemOrderInRepair" },
        { colTitle: "ایجاد توسط", colName: "CreateByName" }
    ]
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
        dispatch(getSystemSettings(settingNames));
        dispatch(getServiceStatusList());
        getHappyCallMetrics(setHappyCallMetrics);
        getHappyCallCatList(setCatList);
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faCogs} size="lg" />&nbsp;
                    تنظیمات رضایت سنجی
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    {!settings || settings === "PENDING" || settings.length <= 10 &&
                        <div style={{ width: "100%", textAlign: "center" }}>
                            <Loader width={30} height={30} color="#bb1370" type="BallTriangle" />
                        </div>
                    }
                    {
                        settings && Array.isArray(settings) && settings.length > 10 &&
                        <Fragment>
                            <form onSubmit={handleSubmit(saveSettings)}>
                                <Row className="rowBorder" style={{ padding: "10px" }}>
                                    <div className="rowTitle">
                                        تنظیمات
                                    </div>
                                    <Col md={5} className="mt-3 rowBorder">
                                        <div className="rowTitle">کلی</div>
                                        <FormGroup className="rowBorder mt-3" style={{ padding: "10px" }}>
                                            <div className="rowTitle">
                                                <label className="ellipsisLabel">کدام سرویس ها جهت انجام رضایت سنجی در لیست ظاهر می شوند؟</label>
                                            </div>
                                            <div className="mt-1">
                                                <input type="checkbox" className="form-check-input" name="Happycall_ShowDeliverdServices" ref={register({})} defaultChecked={findCheckedSetting("Happycall_ShowDeliverdServices")} />&nbsp;
                                                <span>سرویس هایی که حداقل</span>&nbsp;
                                                <input className="tableRowInput" type="number" style={{ width: "50px", height: "22px" }} name="Happycall_Delay_DeliverdServices" ref={register({})} defaultValue={findSetting("Happycall_Delay_DeliverdServices")} />
                                                <span>&nbsp;روز از تاریخ تحویل آن ها گذشته است</span>
                                            </div>
                                            <div className="mt-1">
                                                <input type="checkbox" className="form-check-input" name="Happycall_ShowSentServices" ref={register({})} defaultChecked={findCheckedSetting("Happycall_ShowSentServices")} />&nbsp;
                                                <span>سرویس هایی که حداقل&nbsp;</span>
                                                <input type="number" className="tableRowInput" style={{ width: "50px", height: "22px" }} name="Happycall_Delay_SentServices" ref={register({})} defaultValue={findSetting("Happycall_Delay_SentServices")} />
                                                <span>&nbsp;روز از تاریخ ارسال آن ها گذشته است</span>
                                            </div>
                                            <div className="mt-1">
                                                <input type="checkbox" className="form-check-input mt-2" name="Happycall_ShowServicesInStatus" ref={register({})} defaultChecked={findCheckedSetting("Happycall_ShowServicesInStatus")} />&nbsp;
                                                <span>سرویس هایی که در وضعیت</span>&nbsp;
                                                {statusList === "PENDING" &&
                                                    <div className='tableRowInput' style={{ display: "inline-block", width: "max-content" }}>
                                                        <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                                                        <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری لیست وضعیت</span>
                                                    </div>
                                                }
                                                {statusList && Array.isArray(statusList) &&
                                                    <select className="tableRowInput" name="Happycall_EnteranceStatusID" ref={register({})} style={{ width: "max-content" }}
                                                        defaultValue={findSetting("Happycall_EnteranceStatusID")}>
                                                        <option value="">انتخاب کنید</option>
                                                        {statusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)}
                                                    </select>
                                                }
                                                <span>&nbsp;قرار دارند</span>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={3} className="rowBorder mt-3" style={{ padding: "10px", marginLeft: "10px", marginRight: "10px" }}>
                                        <div className="rowTitle">حد بالای نقاط مرزی</div>
                                        <div className="mt-1" style={{ backgroundColor: "#94c011", width: "60%", padding: "3px", borderRadius: "2px", display: "flex", justifyContent: "space-between" }}>
                                            <label style={{ display: "flex", alignItems: "center" }}>عـالی</label>
                                            <input type="number" className="tableRowInput" value={100} readOnly style={{ width: "50px" }} />
                                        </div>
                                        <div className="mt-1" style={{ width: "60%", backgroundColor: "#0d9495", padding: "3px", borderRadius: "2px", display: "flex", justifyContent: "space-between" }}>
                                            <label style={{ display: "flex", alignItems: "center" }}>متوسط به بالا</label>
                                            <input type="number" className="tableRowInput" name="Happycall_AlarmZone_MotavasetBeBala" defaultValue={findSetting("Happycall_AlarmZone_MotavasetBeBala")} style={{ width: "50px" }} ref={register({})} />
                                        </div>
                                        <div className="mt-1" style={{ width: "60%", backgroundColor: "#b2b2b2", padding: "3px", borderRadius: "2px", display: "flex", justifyContent: "space-between" }}>
                                            <label style={{ display: "flex", alignItems: "center" }}>متوسط</label>
                                            <input type="number" className="tableRowInput" name="Happycall_AlarmZone_Motavaset" defaultValue={findSetting("Happycall_AlarmZone_Motavaset")} style={{ width: "50px" }} ref={register({})} />
                                        </div>
                                        <div className="mt-1" style={{ width: "60%", backgroundColor: "#fcc721", padding: "3px", borderRadius: "2px", display: "flex", justifyContent: "space-between" }}>
                                            <label style={{ display: "flex", alignItems: "center" }}>متوسط به پایین</label>
                                            <input type="number" className="tableRowInput" name="Happycall_AlarmZone_MotavasetBePaeen" defaultValue={findSetting("Happycall_AlarmZone_MotavasetBePaeen")} style={{ width: "50px" }} ref={register({})} />
                                        </div>
                                        <div className="mt-1" style={{ width: "60%", backgroundColor: "#c87239", padding: "3px", borderRadius: "2px", display: "flex", justifyContent: "space-between" }}>
                                            <label style={{ display: "flex", alignItems: "center" }}>ضعیف</label>
                                            <input type="number" className="tableRowInput" name="Happycall_AlarmZone_Zaeef" defaultValue={findSetting("Happycall_AlarmZone_Zaeef")} style={{ width: "50px" }} ref={register({})} />
                                        </div>
                                        <div className="mt-1" style={{ width: "60%", backgroundColor: "#c87239", padding: "3px", borderRadius: "2px", display: "flex", justifyContent: "space-between" }}>
                                            <label style={{ display: "flex", alignItems: "center" }}>مطلقا ضعیف</label>
                                            <input type="number" className="tableRowInput" value={0} readOnly style={{ width: "50px" }} />
                                        </div>
                                    </Col>
                                    <Col md={3} className="mt-3 rowBorder" style={{ padding: "10px" }}>
                                        <div className="rowTitle">پیامک رضایت سنجی</div>
                                        <FormGroup>
                                            <input type="checkbox" className="form-check-input" name="Happycall_SendHappycallSMSAutomatically" ref={register({})} defaultChecked={findCheckedSetting("Happycall_SendHappycallSMSAutomatically")} />&nbsp;
                                            پیامک رضایت سنجی خودکار برای مشتری فرستاده شود
                                        </FormGroup>
                                        <FormGroup>
                                            <label>متن پیامک رضایت سنجی: </label>
                                            <Form.Control as="textarea" rows={3} name="Happycall_SMSBody" ref={register({})} defaultValue={findSetting("Happycall_SMSBody")} />
                                        </FormGroup>
                                        <FormGroup>
                                            <label>مشخصه پاسخ رضایت سنجی: </label>
                                            <Form.Control name="Happycall_SMSAnswerDetector" ref={register({})} defaultValue={findSetting("Happycall_SMSAnswerDetector")} />
                                        </FormGroup>
                                    </Col>
                                    <Button className="group-Btn mt-1" variant="success" type="submit"><CheckLg size={18 }/>&nbsp;ثبت تنظیمات</Button>

                                </Row>
                            </form>
                            <Row className="rowBorder mt-3">
                                <div className="rowTitle">مقیـاس ها</div>
                                <BihamtaTable columns={tableCols} dataList={happyCallMetrics} rowClick={getQuestion} />
                            </Row>
                            <OverlayTrigger trigger="click" placement="top" overlay={popAddEditMetric} show={Number(currentMetric?.ID ?? -1) >= 0}>
                                <Button className="group-Btn-large mt-1" onClick={prepareForAdd}><PlusSquare size={18} />&nbsp; مقیاس جدید</Button>
                            </OverlayTrigger>
                        </Fragment>
                    }
                </Card.Body>
            </Card>
        </div>
    )

}
export default HappyCallSettings;